import React from "react";
import {
	ChatCloseButton,
	ChatMinimizeButton,
	ChannelSportsHeader,
} from "@features/chat/desktop";

export default function ChatHeader() {
	return (
		<div className="chat__header">
			<ChannelSportsHeader />

			<div className="chat__header__actions">
				<ChatMinimizeButton />
				<ChatCloseButton />
			</div>
		</div>
	);
}
